import { z } from 'zod';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["OPEN_EMBEDDED"] = "open-embedded";
  return _EventType2;
})(_EventType || {});
var EmbeddedEvent;
((EmbeddedEvent2) => {
  EmbeddedEvent2.EventType = _EventType;
  const BaseSchema = z.object({
    userId: z.string().optional(),
    agentId: z.string().optional(),
    products: z.array(z.string()).optional()
  });
  EmbeddedEvent2.OpenEmbeddedSchema = BaseSchema.extend({
    type: z.literal("open-embedded" /* OPEN_EMBEDDED */)
  });
  EmbeddedEvent2.Validators = {
    ["open-embedded" /* OPEN_EMBEDDED */]: EmbeddedEvent2.OpenEmbeddedSchema
  };
})(EmbeddedEvent || (EmbeddedEvent = {}));

export { EmbeddedEvent, _EventType };
